module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-05-01",
		"endpointPrefix": "workdocs",
		"jsonVersion": "1.1",
		"protocol": "rest-json",
		"serviceFullName": "Amazon WorkDocs",
		"signatureVersion": "v4",
		"uid": "workdocs-2016-05-01"
	},
	"operations": {
		"AbortDocumentVersionUpload": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId",
					"VersionId"
				],
				"members": {
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"VersionId": {
						"location": "uri",
						"locationName": "VersionId"
					}
				}
			}
		},
		"ActivateUser": {
			"http": {
				"requestUri": "/api/v1/users/{UserId}/activation",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"UserId"
				],
				"members": {
					"UserId": {
						"location": "uri",
						"locationName": "UserId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"User": {
						"shape": "S7"
					}
				}
			}
		},
		"AddResourcePermissions": {
			"http": {
				"requestUri": "/api/v1/resources/{ResourceId}/permissions",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"Principals"
				],
				"members": {
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"Principals": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Id",
								"Type",
								"Role"
							],
							"members": {
								"Id": {},
								"Type": {},
								"Role": {}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ShareResults": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PrincipalId": {},
								"Role": {},
								"Status": {},
								"ShareId": {},
								"StatusMessage": {
									"type": "string",
									"sensitive": true
								}
							}
						}
					}
				}
			}
		},
		"CreateFolder": {
			"http": {
				"requestUri": "/api/v1/folders",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"ParentFolderId"
				],
				"members": {
					"Name": {},
					"ParentFolderId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "Sy"
					}
				}
			}
		},
		"CreateNotificationSubscription": {
			"http": {
				"requestUri": "/api/v1/organizations/{OrganizationId}/subscriptions",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"OrganizationId",
					"Endpoint",
					"Protocol",
					"SubscriptionType"
				],
				"members": {
					"OrganizationId": {
						"location": "uri",
						"locationName": "OrganizationId"
					},
					"Endpoint": {},
					"Protocol": {},
					"SubscriptionType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Subscription": {
						"shape": "S16"
					}
				}
			}
		},
		"CreateUser": {
			"http": {
				"requestUri": "/api/v1/users",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"Username",
					"GivenName",
					"Surname",
					"Password"
				],
				"members": {
					"OrganizationId": {},
					"Username": {},
					"GivenName": {},
					"Surname": {},
					"Password": {
						"type": "string",
						"sensitive": true
					},
					"TimeZoneId": {},
					"StorageRule": {
						"shape": "Si"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"User": {
						"shape": "S7"
					}
				}
			}
		},
		"DeactivateUser": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/users/{UserId}/activation",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"UserId"
				],
				"members": {
					"UserId": {
						"location": "uri",
						"locationName": "UserId"
					}
				}
			}
		},
		"DeleteDocument": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/documents/{DocumentId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId"
				],
				"members": {
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					}
				}
			}
		},
		"DeleteFolder": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/folders/{FolderId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					}
				}
			}
		},
		"DeleteFolderContents": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/folders/{FolderId}/contents",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					}
				}
			}
		},
		"DeleteNotificationSubscription": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/organizations/{OrganizationId}/subscriptions/{SubscriptionId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionId",
					"OrganizationId"
				],
				"members": {
					"SubscriptionId": {
						"location": "uri",
						"locationName": "SubscriptionId"
					},
					"OrganizationId": {
						"location": "uri",
						"locationName": "OrganizationId"
					}
				}
			}
		},
		"DeleteUser": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/users/{UserId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"UserId"
				],
				"members": {
					"UserId": {
						"location": "uri",
						"locationName": "UserId"
					}
				}
			}
		},
		"DescribeDocumentVersions": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/documents/{DocumentId}/versions",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId"
				],
				"members": {
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Include": {
						"location": "querystring",
						"locationName": "include"
					},
					"Fields": {
						"location": "querystring",
						"locationName": "fields"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DocumentVersions": {
						"type": "list",
						"member": {
							"shape": "S1m"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeFolderContents": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/folders/{FolderId}/contents",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					},
					"Sort": {
						"location": "querystring",
						"locationName": "sort"
					},
					"Order": {
						"location": "querystring",
						"locationName": "order"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"Type": {
						"location": "querystring",
						"locationName": "type"
					},
					"Include": {
						"location": "querystring",
						"locationName": "include"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Folders": {
						"type": "list",
						"member": {
							"shape": "Sy"
						}
					},
					"Documents": {
						"type": "list",
						"member": {
							"shape": "S21"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeNotificationSubscriptions": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/organizations/{OrganizationId}/subscriptions",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"OrganizationId"
				],
				"members": {
					"OrganizationId": {
						"location": "uri",
						"locationName": "OrganizationId"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Subscriptions": {
						"type": "list",
						"member": {
							"shape": "S16"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeResourcePermissions": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/resources/{ResourceId}/permissions",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId"
				],
				"members": {
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Principals": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"Type": {},
								"Roles": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Role": {},
											"Type": {}
										}
									}
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeUsers": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/users",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"OrganizationId": {
						"location": "querystring",
						"locationName": "organizationId"
					},
					"UserIds": {
						"location": "querystring",
						"locationName": "userIds"
					},
					"Query": {
						"location": "querystring",
						"locationName": "query",
						"type": "string",
						"sensitive": true
					},
					"Include": {
						"location": "querystring",
						"locationName": "include"
					},
					"Order": {
						"location": "querystring",
						"locationName": "order"
					},
					"Sort": {
						"location": "querystring",
						"locationName": "sort"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Fields": {
						"location": "querystring",
						"locationName": "fields"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Users": {
						"type": "list",
						"member": {
							"shape": "S7"
						}
					},
					"TotalNumberOfUsers": {
						"type": "long"
					},
					"Marker": {}
				}
			}
		},
		"GetDocument": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/documents/{DocumentId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId"
				],
				"members": {
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "S21"
					}
				}
			}
		},
		"GetDocumentPath": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/documents/{DocumentId}/path",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId"
				],
				"members": {
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Fields": {
						"location": "querystring",
						"locationName": "fields"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Path": {
						"shape": "S2n"
					}
				}
			}
		},
		"GetDocumentVersion": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId",
					"VersionId"
				],
				"members": {
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"VersionId": {
						"location": "uri",
						"locationName": "VersionId"
					},
					"Fields": {
						"location": "querystring",
						"locationName": "fields"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "S1m"
					}
				}
			}
		},
		"GetFolder": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/folders/{FolderId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "Sy"
					}
				}
			}
		},
		"GetFolderPath": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/folders/{FolderId}/path",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Fields": {
						"location": "querystring",
						"locationName": "fields"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Path": {
						"shape": "S2n"
					}
				}
			}
		},
		"InitiateDocumentVersionUpload": {
			"http": {
				"requestUri": "/api/v1/documents",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"ParentFolderId"
				],
				"members": {
					"Id": {},
					"Name": {},
					"ContentCreatedTimestamp": {
						"type": "timestamp"
					},
					"ContentModifiedTimestamp": {
						"type": "timestamp"
					},
					"ContentType": {},
					"DocumentSizeInBytes": {
						"type": "long"
					},
					"ParentFolderId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "S21"
					},
					"UploadMetadata": {
						"type": "structure",
						"members": {
							"UploadUrl": {
								"shape": "S1r"
							},
							"SignedHeaders": {
								"type": "map",
								"key": {},
								"value": {}
							}
						}
					}
				}
			}
		},
		"RemoveAllResourcePermissions": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/resources/{ResourceId}/permissions",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId"
				],
				"members": {
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					}
				}
			}
		},
		"RemoveResourcePermission": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/resources/{ResourceId}/permissions/{PrincipalId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"PrincipalId"
				],
				"members": {
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"PrincipalId": {
						"location": "uri",
						"locationName": "PrincipalId"
					},
					"PrincipalType": {
						"location": "querystring",
						"locationName": "type"
					}
				}
			}
		},
		"UpdateDocument": {
			"http": {
				"method": "PATCH",
				"requestUri": "/api/v1/documents/{DocumentId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId"
				],
				"members": {
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"Name": {},
					"ParentFolderId": {},
					"ResourceState": {}
				}
			}
		},
		"UpdateDocumentVersion": {
			"http": {
				"method": "PATCH",
				"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId",
					"VersionId"
				],
				"members": {
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"VersionId": {
						"location": "uri",
						"locationName": "VersionId"
					},
					"VersionStatus": {}
				}
			}
		},
		"UpdateFolder": {
			"http": {
				"method": "PATCH",
				"requestUri": "/api/v1/folders/{FolderId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					},
					"Name": {},
					"ParentFolderId": {},
					"ResourceState": {}
				}
			}
		},
		"UpdateUser": {
			"http": {
				"method": "PATCH",
				"requestUri": "/api/v1/users/{UserId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"UserId"
				],
				"members": {
					"UserId": {
						"location": "uri",
						"locationName": "UserId"
					},
					"GivenName": {},
					"Surname": {},
					"Type": {},
					"StorageRule": {
						"shape": "Si"
					},
					"TimeZoneId": {},
					"Locale": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"User": {
						"shape": "S7"
					}
				}
			}
		}
	},
	"shapes": {
		"S7": {
			"type": "structure",
			"members": {
				"Id": {},
				"Username": {},
				"EmailAddress": {},
				"GivenName": {},
				"Surname": {},
				"OrganizationId": {},
				"RootFolderId": {},
				"RecycleBinFolderId": {},
				"Status": {},
				"Type": {},
				"CreatedTimestamp": {
					"type": "timestamp"
				},
				"ModifiedTimestamp": {
					"type": "timestamp"
				},
				"TimeZoneId": {},
				"Locale": {},
				"Storage": {
					"type": "structure",
					"members": {
						"StorageUtilizedInBytes": {
							"type": "long"
						},
						"StorageRule": {
							"shape": "Si"
						}
					}
				}
			}
		},
		"Si": {
			"type": "structure",
			"members": {
				"StorageAllocatedInBytes": {
					"type": "long"
				},
				"StorageType": {}
			}
		},
		"Sy": {
			"type": "structure",
			"members": {
				"Id": {},
				"Name": {},
				"CreatorId": {},
				"ParentFolderId": {},
				"CreatedTimestamp": {
					"type": "timestamp"
				},
				"ModifiedTimestamp": {
					"type": "timestamp"
				},
				"ResourceState": {},
				"Signature": {}
			}
		},
		"S16": {
			"type": "structure",
			"members": {
				"SubscriptionId": {},
				"EndPoint": {},
				"Protocol": {}
			}
		},
		"S1m": {
			"type": "structure",
			"members": {
				"Id": {},
				"Name": {},
				"ContentType": {},
				"Size": {
					"type": "long"
				},
				"Signature": {},
				"Status": {},
				"CreatedTimestamp": {
					"type": "timestamp"
				},
				"ModifiedTimestamp": {
					"type": "timestamp"
				},
				"ContentCreatedTimestamp": {
					"type": "timestamp"
				},
				"ContentModifiedTimestamp": {
					"type": "timestamp"
				},
				"CreatorId": {},
				"Thumbnail": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S1r"
					}
				},
				"Source": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S1r"
					}
				}
			}
		},
		"S1r": {
			"type": "string",
			"sensitive": true
		},
		"S21": {
			"type": "structure",
			"members": {
				"Id": {},
				"CreatorId": {},
				"ParentFolderId": {},
				"CreatedTimestamp": {
					"type": "timestamp"
				},
				"ModifiedTimestamp": {
					"type": "timestamp"
				},
				"LatestVersionMetadata": {
					"shape": "S1m"
				},
				"ResourceState": {}
			}
		},
		"S2n": {
			"type": "structure",
			"members": {
				"Components": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"Id": {},
							"Name": {}
						}
					}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/workdocs-2016-05-01.min.json
// module id = 496
// module chunks = 0